var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"color":"primary","fab":"","small":"","disabled":!_vm.hasLead || _vm.disabledButton},on:{"click":_vm.redirectToPage}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" mdi-eye")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }